import { ContactDTO } from "./ContactDTO";

export class DiaryNoteDTO {

    constructor(
        public id: string,
        public startDate: string,
        public endDate: string,
        public note: string,
        public title: string | null,
        public startTime: string | null,
        public durationMinutes: number | null,
        public contact: ContactDTO | null,
        public isPublic: boolean
    ) { }
}
